<template>
  <div>
    <search-form @search="handleSearch"></search-form>

    <el-button
      type="primary"
      size="small"
      icon="el-icon-plus"
      @click="handleAdd"
    >
      新增
    </el-button>
    <el-tag type="danger">
      注意：1、【会议前备案】可选择多个【会议抽取】。2、[会议系统]里面一个会议可以使用多个抽取。
    </el-tag>
    <el-table
      :data="tableData"
      v-loading="loading"
      class="mt10"
      border
      fit
      stripe
    >
      <el-table-column
        prop="sortNum"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="workYear"
        label="年度"
        width="60"
      ></el-table-column>
      <el-table-column prop="title" label="名称"></el-table-column>
      <el-table-column prop="id" label="流水号" width="65"></el-table-column>
      <el-table-column
        prop="needCount"
        label="需总数"
        width="80"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <b>{{ scope.row.needCount }}</b>
        </template>
      </el-table-column>
      <el-table-column label="新增时间/状态" width="160">
        <template slot-scope="scope">
          <div>
            {{ moment(scope.row.addTime).format('YYYY-MM-DD HH:mm:ss') }}
          </div>
          <el-tag
            size="medium"
            v-text="scope.row.stateName"
            v-bind:type="scope.row.allowEdit ? 'info' : 'success'"
          ></el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleDelete(scope.row.gainEid)"
            v-show="scope.row.editable"
          >
            删除
          </el-button>
          <el-button
            @click="handleEdit(scope.row)"
            v-if="scope.row.editable"
            type="text"
          >
            编辑
          </el-button>
          <div v-else>
            <el-link @click="handleView(scope.row)" type="primary">
              查看
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="search"
      @current-change="search"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    />
  </div>
</template>
<script>
import SearchForm from '@/components/SearchPositionGain/Board.vue';

import { boardSearch } from '@/api/position/gains/search.js';
import { deleteData } from '@/api/position/gains/base.js';

export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      loading: false,
      tableData: [],
      total: 0
    };
  },
  components: {
    SearchForm
  },
  methods: {
    /** 搜索按钮操作 */
    handleSearch(queryParams) {
      this.query.pageIndex = 1;
      Object.assign(this.query, queryParams);

      this.search();
    },
    handleAdd() {
      window.open('/position/gains/base/', 'gavinAdd');
      this.$alert('我已编辑完成!请单击确定。', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.search();
        }
      });
    },
    handleEdit(row) {
      window.open(`/position/gains/base/${row.gainEid}`, 'gavinEdit');
      this.handelConfirm();
    },
    handleView(row) {
      window.open(`/position/gains/review/${row.gainEid}`, 'gavinReview');
    },
    handleDelete(gainEid) {
      this.$confirm('您确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        deleteData(gainEid).then(res => {
          this.loading = false;
          this.msgSuccess('操作成功！', () => this.search());
        });
      });
    },
    handelConfirm() {
      this.$alert('此抽取操作完成！', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          this.search();
        }
      });
    },
    search() {
      this.loading = true;
      boardSearch(this.query).then(res => {
        this.loading = false;
        this.tableData = res.datas;
        this.total = res.totalRecords;
      });
    }
  },
  created() {
    this.search();
  }
};
</script>
